import {EventEmitter , Injectable} from '@angular/core';
import {model} from './navigation.model';
import {BehaviorSubject} from 'rxjs';
import {FuseConfigService} from '../../services/config.service';
import {accessRightMenu} from '../../../guards/accessRights';
import {ModulesService} from '../../services/modules.service';

@Injectable()
export class FuseNavigationService {
  onNavCollapseToggle = new EventEmitter<any>();
  onNavCollapseToggled = new EventEmitter<any>();
  onNavigationModelChange: BehaviorSubject<any> = new BehaviorSubject({});
  navigationModel;
  flatNavigation: any[] = [];
  accessRight = accessRightMenu;
  role;
  canRecommend;
  allowCompetency;
  constructor (public fuseConfig: FuseConfigService, public modulesService: ModulesService) {
    this.navigationModel = {model: model};
    fuseConfig.role.subscribe((res) => {
      this.role = res;
      if (this.role) {
        this.navigationModel = {model: model};
        this.setNavigationModel(this.navigationModel);
      } else {
        this.role = 'readOnly';
        this.setNavigationModel(this.navigationModel);
      }
    });
    this.fuseConfig.organizationId.subscribe(res => {
      if (res) {
        this.getAllowed(res);
      }
    });
    this.fuseConfig.canRecommend.subscribe(res => {
      this.canRecommend = this.toBoolean(res);
    });
    this.fuseConfig.allowCompetency.subscribe(res => {
      this.allowCompetency = this.toBoolean(res);
    });
  }

  toBoolean(val) {
    if (typeof val === 'boolean') { return val; }
    if (typeof val === 'string') {
      return val.toLowerCase().trim() === 'true';
    }
    return false;
  }

  getAllowed(id) {
    this.modulesService.getByOrganizationId(id).subscribe((res: any) => {
      if (res && res.length) {
        this.navigationModel = {model: model};
        for (let i = 0; i < res.length; i++) {
          if (!res[i].status) {
            let modules = res[i].page.pages.split(',');
            this.navigationModel.model = this.navigationModel.model.filter(el => !modules.includes(el.id));
            for (let j = 0; j < this.navigationModel.model.length; j++) {
              if (this.navigationModel.model[j].children) {
                this.navigationModel.model[j].children = this.navigationModel.model[j].children.filter(el => !modules.includes(el.id));
              }
            }
          }
        }
        let recommendationIndex = this.navigationModel.model.findIndex(el => el.id === 'recommendation');
        if (recommendationIndex >= 0 && this.navigationModel.model[recommendationIndex].children.length === 0) {
          this.navigationModel.model.splice(recommendationIndex, 1);
        }
        this.setNavigationModel(this.navigationModel);
      }
    });
  }

  /**
   * Get navigation model
   *
   * @returns {any[]}
   */
  getNavigationModel () {
    return this.navigationModel.model;
  }

  /**
   * Set the navigation model
   *
   * @param model
   */
  setNavigationModel (model) {
    this.navigationModel = model;
    if (this.role === 'subCountryAdmin' && !this.canRecommend) {
      this.navigationModel.model = this.navigationModel.model.filter(el => el.id !== 'recommend');
    }
    if (this.role === 'organisationAdmin' && !this.allowCompetency) {
      this.navigationModel.model = this.navigationModel.model.map(el => {
        if (el.children) {
          return {
            ...el,
            children: el.children.filter(child => child.id !== 'orgCompetency')
          };
        }
        return el;
      });
    }
    for (let i = 0; i < this.navigationModel.model.length; i++) {
      if (this.accessRight[this.role].includes(this.navigationModel.model[i].id)) {
        this.navigationModel.model[i].show = true;
      } else {
        this.navigationModel.model[ i ].show = false;
      }
      if (this.navigationModel.model[i].children) {
        for (let j = 0; j < this.navigationModel.model[i].children.length; j++) {
          if (this.accessRight[this.role].includes(this.navigationModel.model[i].children[j].id)) {
            this.navigationModel.model[i].children[j].show = true;
          } else {
            this.navigationModel.model[i].children[j].show = false;
          }
        }
      }
    }

    this.onNavigationModelChange.next(this.navigationModel.model);
  }

  /**
   * Add new navigation item
   * to the given location
   */
  addNavigationItem (location , item) {
    // Parse the location
    const locationArr = location.split('.');

    if (locationArr.length === 0) {
      return;
    }

    // Find the navigation item
    const navItem = this.findNavigationItemById(locationArr);

    // Act according to the item type
    switch (navItem.type) {
      case 'item':

        // Create a children array
        navItem.children = [];

        // Push the item
        navItem.children.push(item);

        // Change the item type to collapsable
        navItem.type = 'collapse';

        break;

      case 'collapse':

        // Push the item
        navItem.children.push(item);

        break;

      case 'group':

        // Push the item
        navItem.children.push(item);

        break;

      default:
        break;
    }
  }

  /**
   * Get navigation item from
   * given location
   *
   * @param location
   */
  getNavigationItem (location) {
    // Parse the location
    const locationArr = location.split('.');

    if (locationArr.length === 0) {
      return;
    }

    // Find and return the navigation item
    return this.findNavigationItemById(locationArr);
  }

  /**
   * Find navigation item by location
   *
   * @param location
   * @param navigation
   */
  findNavigationItemById (location , navigation?) {
    if (!navigation) {
      navigation = this.navigationModel.model;
    }

    // Iterate through the given navigation
    for (const navItem of navigation) {
      // If the nav item id equals the first location...
      if (navItem.id === location[ 0 ]) {
        // If there is more location to look at...
        if (location.length > 1) {
          // Remove the first item of the location
          location.splice(0 , 1);

          // Go nested...
          return this.findNavigationItemById(location , navItem.children);
        }

        // Otherwise just return the nav item
        else {
          return navItem;
        }
      }
    }
  }

  /**
   * Get flattened navigation array
   * @param navigationItems
   * @returns {any[]}
   */
  getFlatNavigation (navigationItems?) {
    if (!navigationItems) {
      navigationItems = this.navigationModel.model;
    }

    for (const navItem of navigationItems) {
      if (navItem.type === 'subheader') {
        continue;
      }

      if (navItem.type === 'item') {
        this.flatNavigation.push({
          title: navItem.title ,
          type: navItem.type ,
          icon: navItem.icon || false ,
          url: navItem.url
        });

        continue;
      }

      if (navItem.type === 'collapse' || navItem.type === 'group') {
        this.getFlatNavigation(navItem.children);
      }
    }

    return this.flatNavigation;
  }
}
